//src/pages/SorteiosLeadsLista.jsx

import React, { useEffect, useState } from "react";
import axios from "../axiosConfig";
import { Link } from "react-router-dom";
import { CalendarDays, Eye, Gift, Plus, RefreshCcw, Users } from "lucide-react";
import "./SorteiosLeadsLista.css";

function SorteiosLeadsLista() {
  const [sorteios, setSorteios] = useState([]);
  const [loading, setLoading] = useState(false);
  const [mensagem, setMensagem] = useState("");

  const carregarSorteios = async () => {
    setLoading(true);
    setMensagem("");

    try {
      const { data } = await axios.get("/admin/sorteios-leads");
      setSorteios(Array.isArray(data) ? data : []);
    } catch (err) {
      setMensagem(err.response?.data?.error || "Erro ao carregar sorteios.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarSorteios();
  }, []);

  const formatarData = (valor) => {
    if (!valor) return "-";
    try {
      return new Date(valor).toLocaleString("pt-BR");
    } catch {
      return "-";
    }
  };

  return (
    <div className="sorteiosLeadsLista-page">
      <header className="sorteiosLeadsLista-header">
        <div>
          <span className="sorteiosLeadsLista-kicker">Eventos Tikpag</span>
          <h1>Sorteios de Leads</h1>
          <p>
            Crie sorteios para eventos, gere links públicos de cadastro e acompanhe
            participantes, prêmios e ganhadores.
          </p>
        </div>

        <Link to="/admin/sorteios-leads/novo" className="sorteiosLeadsLista-btn primary">
          <Plus size={17} />
          Novo sorteio
        </Link>
      </header>

      {mensagem && <div className="sorteiosLeadsLista-alert">{mensagem}</div>}

      <section className="sorteiosLeadsLista-card">
        <div className="sorteiosLeadsLista-toolbar">
          <div>
            <h2>Sorteios cadastrados</h2>
            <span>{sorteios.length} registro(s)</span>
          </div>

          <button type="button" onClick={carregarSorteios} disabled={loading}>
            <RefreshCcw size={16} className={loading ? "sorteiosLeadsLista-spin" : ""} />
            Atualizar
          </button>
        </div>

        {sorteios.length === 0 ? (
          <div className="sorteiosLeadsLista-empty">
            Nenhum sorteio cadastrado ainda.
          </div>
        ) : (
          <div className="sorteiosLeadsLista-grid">
            {sorteios.map((sorteio) => (
              <article className="sorteiosLeadsLista-item" key={sorteio.id}>
                <div className="sorteiosLeadsLista-itemTop">
                  <span className={`sorteiosLeadsLista-status ${sorteio.status}`}>
                    {sorteio.status}
                  </span>

                  <span className={Number(sorteio.ativo) ? "sorteiosLeadsLista-ativo" : "sorteiosLeadsLista-inativo"}>
                    {Number(sorteio.ativo) ? "Ativo" : "Inativo"}
                  </span>
                </div>

                <h3>{sorteio.titulo}</h3>
                <p>{sorteio.descricao || "Sem descrição."}</p>

                <div className="sorteiosLeadsLista-meta">
                  <span>
                    <CalendarDays size={15} />
                    {formatarData(sorteio.data_evento)}
                  </span>

                  <span>
                    <Users size={15} />
                    {sorteio.total_participantes || 0} participantes
                  </span>

                  <span>
                    <Gift size={15} />
                    {sorteio.premios_sorteados || 0}/{sorteio.total_premios || 0} prêmios
                  </span>
                </div>

                    <div className="sorteiosLeadsLista-links">
                      <small>Link público:</small>

                      <a
                        href={`https://www.tikpontos.com.br/sorteios/${sorteio.slug}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {`https://www.tikpontos.com.br/sorteios/${sorteio.slug}`}
                      </a>
                    </div>

                <div className="sorteiosLeadsLista-actions">
                  <Link to={`/admin/sorteios-leads/editar/${sorteio.id}`}>
                    Editar
                  </Link>

                  <Link to={`/admin/sorteios-leads/${sorteio.id}/leads`}>
                    Leads
                  </Link>

                  <div className="sorteiosLeadsLista-sorteadorBox">
                    <small>Link do sorteador:</small>
                    <code>{`https://www.tikpontos.com.br/sorteador-login?slug=${sorteio.slug}`}</code>
                    <span>Abra em janela anônima ou em outro navegador, sem login do admin.</span>
                  </div>

                  <Link to={`/admin/sorteios-leads/${sorteio.id}/qrcode`}>
                    QR Code
                  </Link>


                </div>
              </article>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}

export default SorteiosLeadsLista;